import React, { Component } from 'react';

// redux
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

// i18n
import { withTranslation } from 'react-i18next';

import SubscriptionWidget from '../billing/subscriptions/subscription';
import BookCredits from '../book/bookCredits';
import ux from '../../utils/uxAnalyticsUtil';

export class Subscription extends Component {

  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    const { history } = this.props;
    ux.trackPageView(history.location.pathname);
  }

  render() {
    const { t } = this.props;
    return (
      <main className="br-subscription-page">
        <h1>{t('Subscription')}</h1>
        <section className="br-card" aria-label={t('Subscription')}>
          <SubscriptionWidget />
        </section>
        <BookCredits embedded />
      </main>
    );
  }
}

// redux stuff
const mapStateToProps = state => ({
  user: state.user.user,
  idToken: state.user.idToken,
  userProfile: state.user.userProfile,
  socialProfiles: state.user.socialProfiles
});

const mapDispatchToProps = dispatch => bindActionCreators({
}, dispatch);

export default withTranslation()(connect(
  mapStateToProps,
  mapDispatchToProps
)(Subscription));
